import { useLayoutEffect, useRef } from "react";
import { createRoot } from "react-dom/client";
import cssText from "./XsmbV3Dark.shadow.css";
import useXsmbV3Light from "../XsmbV3Light/useXsmbV3Light";

const HOST_STYLE = {
  all: "initial",
  display: "block",
  width: "100%",
  maxWidth: "100%",
  margin: 0,
  padding: 0,
  border: 0,
  background: "transparent",
  boxSizing: "border-box",
  lineHeight: "normal",
  color: "#000",
  fontFamily: "Arial, Helvetica, sans-serif",
  fontSize: "14px",
};

const MB_ROWS = [
  ["db", "Đặc biệt", "1"],
  ["g1", "Giải nhất", "2"],
  ["g2", "Giải nhì", "3"],
  ["g3", "Giải ba", "4"],
  ["g4", "Giải tư", "5"],
  ["g5", "Giải năm", "6"],
  ["g6", "Giải sáu", "7"],
  ["g7", "Giải bảy", "8"],
];

function regionCaption(name, draw) {
  return `Xổ số ${name} ${draw.weekdayLong} ${draw.dash}`;
}

function NumberGrid({ values, prize, quantity }) {
  return (
    <div className="quantity-of-number" data-quantity={quantity}>
      {values.map((value, index) => (
        <span className="number" data-prize={prize} data-value={value} key={`${prize}-${index}`}>
          {value}
        </span>
      ))}
    </div>
  );
}

function ResultTable({ view }) {
  const caption = regionCaption(view.label, view.draw);
  if (view.pending || !view.stations.length) {
    return (
      <table className="table-fixed tbldata table-result-lottery">
        <caption>
          <h2>{caption}</h2>
        </caption>
        <tbody>
          <tr className="empty-row">
            <td>{view.pending ? "Đang tải kết quả..." : `Chưa có dữ liệu cho ngày ${view.draw.slash}.`}</td>
          </tr>
        </tbody>
      </table>
    );
  }

  return (
    <table className="table-fixed tbldata table-result-lottery">
      <caption>
        <h2>{caption}</h2>
      </caption>
      <tbody>
        {MB_ROWS.map(([key, label, prize]) => {
          const values = view.stations[0].prizes[key] || [];
          return (
            <tr key={key}>
              <td className="prize">{label}</td>
              <td className="results">
                <NumberGrid values={values} prize={prize} quantity={values.length || 1} />
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}

function XsmbV3Dark() {
  const view = useXsmbV3Light();
  return (
    <div className="xsmb-dark">
      <div className="block-results">
        <div className="block-result">
          <ResultTable view={view} />
        </div>
      </div>
    </div>
  );
}

function XsmbV3DarkHost() {
  const hostRef = useRef(null);
  const rootRef = useRef(null);

  useLayoutEffect(() => {
    const host = hostRef.current;
    if (!host) return undefined;
    const shadow = host.shadowRoot ?? host.attachShadow({ mode: "open" });
    let style = shadow.querySelector("style[data-xsmb-v3-dark]");
    if (!style) {
      style = document.createElement("style");
      style.setAttribute("data-xsmb-v3-dark", "");
      shadow.appendChild(style);
    }
    style.textContent = cssText;
    let mount = shadow.querySelector("[data-xsmb-dark-mount]");
    if (!mount) {
      mount = document.createElement("div");
      mount.setAttribute("data-xsmb-dark-mount", "");
      shadow.appendChild(mount);
    }
    if (!rootRef.current) rootRef.current = createRoot(mount);
    rootRef.current.render(<XsmbV3Dark />);
    return () => {
      rootRef.current?.unmount();
      rootRef.current = null;
    };
  }, [cssText]);

  return <div ref={hostRef} className="xsmb-dark-host" style={HOST_STYLE} />;
}

export default XsmbV3DarkHost;
